const breakpoints = {
    start: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1340
};

export default breakpoints;
